export enum QueryKey {
  Agents = 'agents',
  Profile = 'profile',
  TwoFA = 'two-fa',
  Users = 'users',
  UsersPaginated = 'users-paginated',
  Merchants = 'merchants',
  UsersMerchants = 'users-merchants',
  UserInvite = 'user-invite',
  Assets = 'assets',
  MyAssets = 'my-assets',
  TradersAssets = 'traders-assets',
  MerchantsAssets = 'merchants-assets',
  PlatformAssets = 'platform-assets',
  MyInfo = 'my-info',
  MerchantMyInfo = 'merchant-my-info',
  ShopAssets = 'shop-assets',
  FundsRequests = 'funds-requests',
  InternalTransfers = 'internal-transfers',
  InternalTransfersUsers = 'internal-transfers-users',
  MyFundsRequests = 'my-funds-requests',
  Shops = 'shops',
  ShopsPaginated = 'shops-paginated',
  ShopIntegrations = 'shop-integrations',
  ShopPayoutTradeMethodsConfig = 'shop-payout-trade-methods-config',
  Requisites = 'requisites',
  RequisitesCustomerAssignments = 'requisite-customer-assginments',
  RequisitesWhiteTriangle = 'requisites-white-triangle',
  RequisitesGroups = 'requisites-groups',
  RequisitesGroupsPaginated = 'requisites-groups-paginated',
  RequisitesTelegramAutomation = 'requisites-telegram-automation',
  PayoutRequisites = 'payout-requisites',
  PayoutRequisitesAutomation = 'payout-requisites-automation',
  PayoutRequisitesAutomationWarnings = 'payout-requisites-automation-warnings',
  PayoutRequisitesAutomationConfig = 'payout-requisites-automation-config',
  PayoutRequisitesBalanceRedistribution = 'payout-requisites-balance-redistribution',
  PayoutOrderAutomations = 'payout-order-automations',
  PayoutOrderAutomationRequests = 'payout-order-automation-requests',
  PayoutOrderCurrentCascadeAssignee = 'payout-order-current-cascade-assignee',
  UserReferrals = 'user-referrals',
  ShopReferrals = 'shop-referrals',
  Order = 'order',
  ActiveOrders = 'active-orders',
  CompletedOrders = 'completed-orders',
  CancelledOrders = 'cancelled-orders',
  ExportOrdersColumns = 'export-orders-columns',
  ActivePayoutOrders = 'active-payout-orders',
  CompletedPayoutOrders = 'completed-payout-orders',
  CancelledPayoutOrders = 'cancelled-payout-orders',
  DisputePayoutOrders = 'dispute-payout-orders',
  ExportPayoutOrdersColumns = 'export-payout-orders-columns',
  PayinOrderReceipts = 'payin-order-receipts',
  PayoutOrderReceipts = 'payout-order-receipts',
  DisputeOrders = 'dispute-orders',
  TraderDisputeOrders = 'trader-dispute-orders',
  ProviderDisputeOrders = 'provider-dispute-orders',
  Traders = 'traders',
  TraderActiveOrdersCount = 'trader-active-orders-count',
  TradersPaginated = 'traders-paginated',
  UsersTraders = 'users-traders',
  Notifications = 'notifications',
  AssetBalanceHistory = 'asset-balance-history',
  CurrencyExchangeRates = 'currency-exchange-rates',
  CurrencyExchange = 'currency-exchange',
  FiatCurrencyExchange = 'fiat-currency-exchange',
  AssetCurrencyExchange = 'asset-currency-exchange',
  AssetCurrencyExchangeRequests = 'asset-currency-exchange-requests',
  UserAssetCurrencyExchange = 'user-asset-currency-exchange',
  Groups = 'groups',
  MerchantOperators = 'merchant-operators',
  MerchantGroups = 'merchant-groups',
  RequisitesDistribution = 'requisites-distribution',
  RequisitesDistributionDebug = 'requisites-distribution-debug',
  AssetCurrencies = 'asset-currencies',
  FiatCurrencies = 'fiat-currencies',
  Banks = 'banks',
  Bins = 'bins',
  BankAliases = 'bank-aliases',
  BanksNotArchive = 'banks-not-archive',
  BanksArchive = 'banks-archive',
  TradeMethods = 'trade-methods',
  ShopPayinTradeMethods = 'shop-payin-trade-methods',
  TradeMethodsNotArchive = 'trade-methods-not-archive',
  TradeMethodsArchive = 'trade-methods-archive',
  TradeMethodPayoutPDFTemplates = 'trade-method-payout-pdf-templates',
  ParsingMethods = 'parsing-methods',
  ParsingMethodsParse = 'parsing-methods-parse',
  PaymentTypes = 'payment-types',
  RequisiteLimits = 'requisite-limits',
  PayinRequisitesLimits = 'payin-requisites-limits',
  PayoutRequisitesAutomationLimits = 'payout-requisites-automation-limits',
  PlatformLimits = 'platform-limits',
  Meta = 'meta',
  Operators = 'operators',
  OrderExistsByRequisites = 'order_exists_by_requisites',
  PayoutOrderExistsByRequisites = 'payout_order_exists_by_requisites',
  NewAnomalies = 'new_anomalies',
  AnomaliesLastSearchAt = 'anomalies_last_search_at',
  ReviewedAnomalies = 'reviewed_anomalies',
  ActivePayoutOrderAutomation = 'active-payout-order-automation',
  RejectedPayoutOrderAutomation = 'rejected-payout-order-automation',
  ErrorPayoutOrderAutomation = 'error-payout-order-automation',
  CancelledPayoutOrderAutomation = 'cancelled-payout-order-automation',
  CompletedPayoutOrderAutomation = 'completed-payout-order-automation',
  AllPayoutOrderAutomation = 'all-payout-order-automation',
  ActiveOrderAutomation = 'active-order-automation',
  ArchiveOrderAutomation = 'archive-order-automation',
  AllOrderAutomation = 'all-order-automation',
  ErrorOrderAutomation = 'error-order-automation',
  ErrorReviewedOrderAutomation = 'error-reviewed-order-automation',
  TemplateErrorOrderAutomation = 'template-error-order-automation',
  TemplateErrorHandledOrderAutomation = 'template-error-handled-order-automation',
  SpamOrderAutomation = 'spam-order-automation',
  TechnicalOrderAutomation = 'technical-order-automation',
  AutomationSources = 'automation-sources',
  Deeplinks = 'deeplinks',
  Webhooks = 'webhooks',
  WebhooksHistory = 'webhooks-history',
  AgentsStatisticSummary = 'agents-statistic-summary',
  SummaryStatistic = 'summary-statistic',
  DailySummaryStatistic = 'daily-summary-statistic',
  RequisitesStatistic = 'requisites-statistic',
  DailyRequisitesStatistic = 'daily-requisites-statistic',
  PayinProviderConversion = 'payin-provider-conversion',
  PayinProviderLossPoints = 'payin-provider-loss-points',
  PayinProviderTimings = 'payin-provider-timings',
  PayinProviderIntegrationHealth = 'payin-provider-integration-health',
  PayinProviderErrors = 'payin-provider-errors',
  PayinProviderCancelReasons = 'payin-provider-cancel-reasons',
  PayinProviderNotAssignedReasons = 'payin-provider-not-assigned-reasons',
  OrderStatusHistory = 'order-status-history',
  InternalWalletHolders = 'internal-wallet-holders',
  InternalUsersWallets = 'internal-users-wallets',
  InternalPlatformWallets = 'internal-platform-wallets',
  InternalPlatformWalletConfig = 'internal-platform-wallet-config',
  InternalP2PProviderWallets = 'internal-p2p-providers-wallets',
  InternalP2PProviderWalletsPaginated = 'internal-p2p-providers-wallets-paginated',
  InternalWalletsArchive = 'internal-wallets-archive',
  InternalWalletTransactionsDepositActive = 'platform-wallet-transactions-deposit-active',
  InternalWalletTransactionsDepositArchive = 'platform-wallet-transactions-deposit-archive',
  InternalWalletTransactionsWithdrawalActive = 'platform-wallet-transactions-withdrawal-active',
  InternalWalletTransactionsWithdrawalArchive = 'platform-wallet-transactions-withdrawal-archive',
  OrderCashback = 'order-cashback',
  CascadesCashback = 'cascades-cashback',
  SciDomains = 'sci-domains',
  UserAudit = 'user-audit',
  PayoutOrderStatusHistory = 'payout-order-status-history',
  BalanceReconciliationPlatform = 'balance-reconciliation-platform',
  BalanceReconciliationUsers = 'balance-reconciliation-users',
  UserWallets = 'user-wallets',
  ExternalWalletHolders = 'external-wallet-holders',
  P2PProviderPayinWebhooks = 'p2p-provider-payin-order-webhooks',
  P2PProviderPayinRequests = 'p2p-provider-payin-order-requests',
  P2PProviderPayoutWebhooks = 'p2p-provider-payout-order-webhooks',
  P2PProviderPayoutRequests = 'p2p-provider-payout-order-requests',
  MerchantPayinRequests = 'merchant-payin-order-requests',
  MerchantPayoutRequests = 'merchant-payout-order-requests',
  P2PProviderPayinWebhooksList = 'p2p-provider-payin-webhooks-list',
  P2PProviderPayoutWebhooksList = 'p2p-provider-payout-webhooks-list',
  P2PProviderPayinCustomerDailyLimits = 'p2p-provider-payin-customer-daily-limits',
  P2PProviders = 'p2p-providers',
  P2PProvidersArchive = 'p2p-providers-archive',
  P2PProvidersBalances = 'p2p-providers-balances',
  BlockedCustomers = 'blocked-customers',
  Cascades = 'cascades',
  TrustedCustomers = 'trusted-customers',
  TelegramFlowTraders = 'telegram-flow-traders',
  TelegramFlowShops = 'telegram-flow-shops',
  TelegramFlowProviders = 'telegram-flow-providers',
  TelegramUsers = 'telegram-users',
  Configs = 'configs',
  ConfigsSchemas = 'configs-schemas',
  BlockedCustomersHistory = 'blocked-customers-history',
  ExecutionMetrics = 'execution-metrics',
  PayinOrdersMonitoring = 'payin-orders-monitoring',
  PayoutOrdersMonitoring = 'payout-orders-monitoring',
  LimitsUpdatesHistory = 'limits-updates-history',
  NspkDetails = 'nspk-details',
  Counterparties = 'counterparties',
  OrderSciEvents = 'order-sci-events',
  DynamicAdapterConfigs = 'dynamic-adapter-configs',
  ProviderTypes = 'provider-types',
}
